<div class="app-admin-wrap layout-survey clearfix">
<!--    <div class="side-content-wrap">-->
<!--        <app-sidebar-compact></app-sidebar-compact>-->
<!--    </div>-->
    <div class="main-content-wrap d-flex flex-column"
    >
        <div class="main-content">
            <router-outlet></router-outlet>
        </div>

        <app-footer></app-footer>
        <div class="module-loader" *ngIf="moduleLoading">
            <div class="spinner spinner-bubble spinner-bubble-primary me-3"></div>
        </div>
    </div>
</div>
